import { useTranslation } from 'next-i18next';
import { useEffect, useState } from 'react';
import { useSelector } from '../../../../reduxToolkit/typedRedux';
import { getAllMatches } from '../../../../services/services';
import { GuestSearch } from '../../../account/guestmanagement/GuestSearch';
import LastMatches from '../../../account/matching/LastMatches';
import { MatchesTable } from '../../../account/matching/MatchesTable';
import { TabContentInterface } from '../PBBooths';

const DEFAULT_LIMIT = 25;
const MatchesList = ({ setActions }: TabContentInterface) => {
  const { t } = useTranslation();

  const event = useSelector((state) => state.common.event);

  const [matches, setMatches] = useState<any>([]);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(DEFAULT_LIMIT);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);

  const [searchEmail, setSearchEmail] = useState<string>();

  async function fetch() {
    if (!event) return;
    setLoading(true);
    try {
      const { data, total: _total } = await getAllMatches(event._id, page * limit, limit, searchEmail);
      setMatches(data);
      setTotal(_total);
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  }

  useEffect(() => {
    fetch();
    setActions([]);
  }, [event, page, limit, searchEmail]);

  return (
    <>
      <LastMatches />
      {matches.length > 0 && (
        <GuestSearch handleSearch={(v) => v?.search && setSearchEmail(v?.search)} handleClearSearch={() => setSearchEmail(undefined)} isLoading={loading} />
      )}
      <MatchesTable
        matches={matches}
        isLoading={loading}
        totalRowCount={total}
        pageSize={limit}
        page={page}
        onLimitChange={(limit) => setLimit(limit)}
        onPageChange={(page) => setPage(page)}
      />
    </>
  );
};
export default MatchesList;
